export default __webpack_public_path__ + "static/media/aiHeaderBtnFlat.1ad00157.svg";